import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_IMAGE_ANALYZE_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_IMAGE_ANALYZE_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_IMAGE_ANALYZE_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_IMAGE_ANALYZE_SUCCESS`;
export const INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_IMAGE_ANALYZE_FAILURE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ESTIMATOR_IMAGE_ANALYZE_FAILURE`;
/**
 * Action creator for requesting estimator image analyze
 * @param companyCode - The company code
 * @param batchId - The batch ID
 * @returns Action with type and payload
 */
export const photoCaptureIntelligentEstimatorImageAnalyzeRequestAction = (companyCode, batchId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_IMAGE_ANALYZE_REQUEST,
    payload: { companyCode, batchId }
});
/**
 * Action creator for successful estimator image analyze
 * @param response - The image analyze response data
 * @returns Action with type and payload
 */
export const photoCaptureIntelligentEstimatorImageAnalyzeSuccessAction = (response) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_IMAGE_ANALYZE_SUCCESS,
    payload: { response }
});
/**
 * Action creator for failed estimator image analyze
 * @param batchId - The batch ID
 * @returns Action with type and payload
 */
export const photoCaptureIntelligentEstimatorImageAnalyzeFailureAction = (batchId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_IMAGE_ANALYZE_FAILURE,
    payload: { batchId }
});
//# sourceMappingURL=photoCaptureIntelligentEstimatorImageAnalyzeAction.js.map